export const SASSMALL_CUSTOMER_API_PREFIX = "/apph5/customer-api";
export const SASSMALL_TOKEN_KEY = "sassmall-app-token";
export const SASSMALL_TENANT_DOMAIN_KEY = "sassmall-tenant-domain";
export const SASSMALL_AUTH_MODE_KEY = "sassmall-auth-mode";
export const SASSMALL_AGREEMENT_ACCEPTED_KEY = "sassmall-agreement-accepted";
export const SASSMALL_CONFIRM_ORDER_KEY = "sassmall-confirm-order";
export const SASSMALL_CONFIRM_ORDER_SOURCE_KEY = "sassmall-confirm-order-source";
export const SASSMALL_TENANT_DOMAIN_HEADER = "X-Tenant-Domain";
export const SASSMALL_LOCAL_TENANT_DOMAIN = "1780566943492.localhost";
export const SASSMALL_BOOTSTRAP_SITE_URL =
  "http://xjhy-sass-mall.m-shop-test.omszt.com:7888";
